import { render, staticRenderFns } from "./StrdN_Total.vue?vue&type=template&id=088b5ef6"
import script from "./StrdN_Total.vue?vue&type=script&lang=js"
export * from "./StrdN_Total.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports